import React from 'react';
import { Link } from 'react-router-dom';

import { Icon, IconKebab, IconStopwatch } from '@flixbus/honeycomb-icons-react';
import { Button, Tag } from '@flixbus/honeycomb-react';

import {
	crewDataNA,
	DOMICILE_LABEL,
	EB_OPERATOR_LABEL,
	RRO_OPERATOR_LABEL,
} from 'constants/crewDetails';
import AvailabilityStatusBadge from 'pages/CrewTimeline/components/AvailabilityStatusBadge';
import { minutesDuration } from 'utils/datetime';

import styles from './styles.module.css';

const getClassificationTypeLabel = (currentRun) => {
	return currentRun === undefined
		? crewDataNA
		: currentRun === null
			? EB_OPERATOR_LABEL
			: RRO_OPERATOR_LABEL;
};

const DriverList = ({ isCurrentPeriod, drivers, onToday }) => {
	return (
		<div className={styles.leftColumn}>
			<div className={styles.headerCell}>
				{onToday && (
					<div className={styles.todayBtnWrapper}>
						<Button onClick={onToday} disabled={isCurrentPeriod} extraClasses={styles.todayTLBtn}>
							Today
						</Button>
					</div>
				)}
			</div>
			{drivers.map(
				({
					id,
					fullName,
					driverCard,
					locationLabel,
					location,
					currentHomeBase,
					driverStatus,
					idleTimeMinutes,
					currentRun,
				}) => (
					<div key={id} className={styles.driverCell}>
						<Link to={`/crew-management/${id}`} className={styles.employee}>
							<div className={styles.name}>{fullName}</div>
							<div className={styles.driverCard}>{driverCard || crewDataNA}</div>
							<div className={styles.location}>
								{locationLabel}: {location}
							</div>
							<p className={styles.domicile}>
								<span className={styles.domicileLabel}>{DOMICILE_LABEL}: </span>{' '}
								{currentHomeBase?.city?.name ?? crewDataNA}
							</p>
							<div className={styles.footerInfo}>
								<div className={styles.statusInfo}>
									<AvailabilityStatusBadge driverStatus={driverStatus} />

									<Tag display="outlined" small>
										{getClassificationTypeLabel(currentRun)}
									</Tag>

									{driverStatus.status === 'idle' && idleTimeMinutes && (
										<Tag display="outlined" small>
											<Icon InlineIcon={IconStopwatch} />
											{minutesDuration(idleTimeMinutes)}
										</Tag>
									)}
								</div>
								<Icon InlineIcon={IconKebab} />
							</div>
						</Link>
					</div>
				)
			)}
		</div>
	);
};

export default DriverList;
